export const PAY_CYCLE_OPTIONS = [
  { value: "Weekly", label: "Weekly" },
  { value: "Bi-weekly", label: "Bi-weekly" },
  { value: "Semi-monthly", label: "Semi-monthly" },
  { value: "Monthly", label: "Monthly" },
];

export const COMPENSATION_TYPE_OPTIONS = [
  { value: "Salary", label: "Salary" },
  { value: "Hourly", label: "Hourly" },
  { value: "Commission", label: "Commission" },
];
